import api from './api';

export interface EmailTemplateOverview {
  template_id: string;
  name: string;
  description: string;
  subject_preview: string;
  variables: string[];
  html_template: string;
}

export const emailTemplatesService = {
  list: async (): Promise<EmailTemplateOverview[]> => {
    const response = await api.get('/email/templates');
    return response.data.templates || [];
  },
};
